import React from "react";
import styled from "styled-components";
import { useMappedState } from "redux-react-hook";

import { Text } from "src/library/components/Text";
import { IStore } from "src/core/shared/store";

export interface InvalidWidgetFiltersProps {
  mustNotContain?: Array<"customer" | "branch">
}

// Renders content for invalid widget filters
const InvalidWidgetFilters: React.FunctionComponent<InvalidWidgetFiltersProps> = ({ mustNotContain }) => {
  const { terminology } = useMappedState(({ global }: IStore) => ({ terminology: global.settings?.terminology }));

  if (!mustNotContain || !terminology) {
    return null;
  }

  return (
    <StyledWrapper>
      <Text>
        {`This widget is not available when filtering by ${terminology.customer.singular.text} or ${terminology.drop.singular.text} .`}
      </Text>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default InvalidWidgetFilters;